import React, { useState } from 'react';
import { Button } from '@digitools/honest-react';
import { useTranslation } from 'react-i18next';
import Card from '../../../../../components/Cards/Card';
import ReviewField from '../../../../cli/pages/review/ReviewField';
import checkDate from '../../../utilities/checkDate';
import titleCase from '../../../utilities/titleCase';
import styled from 'styled-components';
import useTranslate from 'src/hooks/useTranslate';
const EVENT_INCREMENT = 6;
const StyledContainerDiv = styled('div') `
  flex-wrap: no-wrap;
  @media (max-width: 440px) {
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
const StyledColumnDiv = styled('div') `
  @media (min-width: 440px) {
    margin:0px 2px 0px 2px;
    flexGrow: 1;

  }
  @media (max-width: 440px) {
    flex: 0 0 100%;
  }
`;
const StyledTwoColumnDiv = styled('div') `
  @media (min-width: 440px) {
    margin:0px 2px 0px 2px;
    flexGrow: 1;

  }
  @media (max-width: 440px) {
    flex: 0 0 48%;
  }
`;
const LeaveBalanceCard = ({ leaveBalanceList, }) => {
    const { t: ot } = useTranslation();
    const { t } = useTranslate();
    const [numEventsToDisplay, setNumEventsToDisplay] = useState(EVENT_INCREMENT);
    const Heading = (docType, docTitle) => {
        return <>{docType}&nbsp;-&nbsp;{docTitle}</>;
    };
    const ariaLabelForField = (label, value) => `${label}: ${value || 'N/A'}`;
    return (<div id='LeaveBalance-container' style={{ width: '100%', display: 'flex', marginBottom: '1rem' }}>
        <div id='leaveBalance-content' style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
          {leaveBalanceList.map((leaveBalance, i) => {
            if (i >= numEventsToDisplay) {
                return <></>;
            }
            return (<>
                <Card data-testid={`leaveBalanceCard`} key={`leaveBalanceCard`} heading={Heading(leaveBalance.program, leaveBalance.lve_pgm_cde)} fontSize='large' small={true}>
                  <StyledContainerDiv style={{ display: 'flex', justifyContent: 'space-between' }}>
                    
                    <StyledColumnDiv className='mb-2'>
                      <ReviewField label={titleCase(ot('programHoursUsedText'))} value={leaveBalance.timeUsed + " " + t({ english: "hours:minutes", spanish: "horas:minutos" })} aria-label={ariaLabelForField(titleCase(ot('programHoursUsedText')), leaveBalance.timeUsed + " " + t({ english: "hours:minutes", spanish: "horas:minutos" }))}/>
                    </StyledColumnDiv>
                    
                    <StyledColumnDiv className='mb-2'>
                      <ReviewField data-testid={'programHoursRemainingText'} label={titleCase(ot('programHoursRemainingText'))} value={leaveBalance.timeRemain + " " + t({ english: "hours:minutes", spanish: "horas:minutos" })} aria-label={ariaLabelForField(titleCase(ot('programHoursRemainingText')), leaveBalance.timeRemain + " " + t({ english: "hours:minutes", spanish: "horas:minutos" }))}/>
                    </StyledColumnDiv>
                    <StyledTwoColumnDiv className='mb-2'>
                      <ReviewField label={titleCase(ot('qualified'))} value={leaveBalance.lvePgmQualdCde === 'QF' ? 'Yes' : 'No'} aria-label={ariaLabelForField(titleCase(ot('qualified')), leaveBalance.lvePgmQualdCde === 'QF' ? 'Yes' : 'No')}/>
                    </StyledTwoColumnDiv>
                    
                    <StyledColumnDiv className='mb-2'>
                      <ReviewField label={titleCase(ot('qualifiedThrough'))} value={checkDate(leaveBalance.lvePgmQualdThruDte) || ''} aria-label={ariaLabelForField(titleCase(ot('qualifiedThrough')), checkDate(leaveBalance.lvePgmQualdThruDte) || 'Undefined')}/>
                    </StyledColumnDiv>
                    
                    <StyledColumnDiv className='mb-2'>
                      <ReviewField label={titleCase(ot('eligible'))} value={leaveBalance.lvePgmEligCde === 'EL' ? 'Yes' : 'No'} aria-label={ariaLabelForField(titleCase(ot('eligible')), leaveBalance.lvePgmEligCde === 'EL' ? 'Yes' : 'No')}/>
                    </StyledColumnDiv>
                    
                    <StyledTwoColumnDiv className='mb-2'>
                      <ReviewField label={titleCase(ot('eligibleThrough'))} value={checkDate(leaveBalance.lvePgmEligThruDte)} aria-label={ariaLabelForField(titleCase(ot('eligibleThrough')), checkDate(leaveBalance.lvePgmEligThruDte) || 'Undefined')}/>
                    </StyledTwoColumnDiv>
                    
                    <StyledColumnDiv className='mb-2' style={{ minWidth: '33px' }}>
                    {leaveBalance.program !== "Federal" &&
                    <ReviewField label={titleCase(ot('state'))} value={leaveBalance.lvePgmStateCde} aria-label={ariaLabelForField(titleCase(ot('state')), leaveBalance.lvePgmStateCde)}/>}
                      </StyledColumnDiv>
                  </StyledContainerDiv>
                </Card>
              </>);
        })}
          {numEventsToDisplay < leaveBalanceList?.length && (<Button style={{ justifyContent: 'center' }} buttonType='text' onClick={() => setNumEventsToDisplay(numEventsToDisplay + (EVENT_INCREMENT))}>
              Show more
            </Button>)}
          {numEventsToDisplay >= leaveBalanceList?.length && numEventsToDisplay > (EVENT_INCREMENT) && (<Button style={{ justifyContent: 'center' }} buttonType='text' onClick={() => setNumEventsToDisplay(numEventsToDisplay - (EVENT_INCREMENT))}>
              Show less
            </Button>)}
        </div>
      </div>);
};
export default LeaveBalanceCard;
